export default __webpack_public_path__ + "static/media/groups_container.5ff10ffe.png";